import { HotKey, parseHotkey } from "is-hotkey";
import { KeyboardEvent, MouseEvent, TouchEvent } from "react";
import { Editor, Element } from "slate";

import { EditorElementType, Mark } from "@smart/itops-serialisation-basic";

import { ModalOption } from "./types";
import { IconName } from "../../icon";

export const hotkeyLabel = (hotkey?: HotKey) =>
  hotkey
    ? [
        hotkey.ctrlKey && "Ctrl",
        hotkey.metaKey && "Cmd",
        hotkey.altKey && "Alt",
        hotkey.shiftKey && "Shift",
        hotkey.key?.toLocaleUpperCase(),
      ]
        .filter(Boolean)
        .join(" + ")
    : undefined;

export const marks: Record<
  Mark,
  { icon: IconName; hotkey?: HotKey; text?: string }
> = {
  bold: {
    icon: "regularBold",
    hotkey: parseHotkey("mod+b", { byKey: true }),
    text: "Bold",
  },
  italic: {
    icon: "regularItalic",
    hotkey: parseHotkey("mod+i", { byKey: true }),
    text: "Italic",
  },
  underline: {
    icon: "regularUnderline",
    hotkey: parseHotkey("mod+u", { byKey: true }),
    text: "Underline",
  },
};
export const markOptions: Mark[] = ["bold", "italic", "underline"];

export const isMarkActive = (editor: Editor, mark: Mark) => {
  const selected = Editor.marks(editor);
  return selected ? selected[mark] === true : false;
};

export const toggleMark =
  (editor: Editor, mark: Mark) =>
  (e: KeyboardEvent | MouseEvent | TouchEvent) => {
    e.preventDefault();
    const isActive = isMarkActive(editor, mark);

    if (isActive) {
      Editor.removeMark(editor, mark);
    } else {
      Editor.addMark(editor, mark, true);
    }
  };

export const modals: Record<
  ModalOption,
  { icon: IconName; pressedIcon: IconName; hotkey?: HotKey; text?: string }
> = {
  link: {
    icon: "regularLink",
    pressedIcon: "solidLink",
    hotkey: parseHotkey("mod+k", { byKey: true }),
    text: "Insert Link",
  },
};

export const isBlockActive = (editor: Editor, types: EditorElementType[]) => {
  const { selection } = editor;
  if (!selection) return false;

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) =>
        !Editor.isEditor(n) && Element.isElement(n) && types.includes(n.type),
    }),
  );

  return !!match;
};
